import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CallType } from '@prostostroy/shared';

export interface IncomingCallInfo {
  callId: string;
  callerId: string;
  callerName: string;
  callerAvatarUrl: string | null;
  conversationId: string | null;
  type: CallType;
  createdAt: string;
}

export interface ActiveCallInfo {
  callId: string;
  type: CallType;
  livekitUrl: string;
  token: string;
  peer: { id: string; name: string; avatarUrl: string | null } | null;
  direction: 'incoming' | 'outgoing';
  conversationId: string | null;
}

export interface CallsState {
  incoming: IncomingCallInfo | null;
  active: ActiveCallInfo | null;
}

const initialState: CallsState = { incoming: null, active: null };

const callsSlice = createSlice({
  name: 'calls',
  initialState,
  reducers: {
    incomingCallReceived(state, action: PayloadAction<IncomingCallInfo>) {
      state.incoming = action.payload;
    },
    incomingCallCleared(state) {
      state.incoming = null;
    },
    activeCallSet(state, action: PayloadAction<ActiveCallInfo>) {
      state.active = action.payload;
      state.incoming = null;
    },
    activeCallCleared(state) {
      state.active = null;
    },
  },
});

export const { incomingCallReceived, incomingCallCleared, activeCallSet, activeCallCleared } =
  callsSlice.actions;

export default callsSlice.reducer;

export const selectIncomingCall = (s: { calls: CallsState }) => s.calls.incoming;
export const selectActiveCall = (s: { calls: CallsState }) => s.calls.active;
